import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '../components/pages'
import pageRouters from './pageRouters'

Vue.use(Router)

const routes = [
  {
    path: '',
    component: IndexPage,
    redirect: 'user',
    children: [
      ...pageRouters
    ]
  }
]

const router = new Router({
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (!to.matched || to.matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default router
